import { web3_api } from "@/api/index.js";

function recharge1(data, user_address) {
  const {
    contract,
    receiver,
    amount_str,
    signature_ts,
    signature,
    rw_contract,
  } = data;
  return new Promise(async (resolve, reject) => {
    try {
      const rwContract = await web3_api.getContractInstance(
        "wallet",
        rw_contract,
      );
      rwContract.methods
        .recharge1(contract, receiver, amount_str, signature_ts, signature)
        .send({ from: user_address })
        .on("receipt", (res) => {
          if (res.status === true || res.status === 1 || res.status === 1n) {
            resolve(res);
          } else {
            reject(new Error("Transaction reverted or failed on-chain"));
          }
        })
        .on("error", (error) => {
          return reject(error);
        });
    } catch (error) {
      console.log(error);

      return reject(error);
    }
  });
}

function withdraw1(data, user_address) {
  const {
    contract,
    amount_str,
    fee_str,
    real_amount_str,
    signature_ts,
    signature,
    withdraw_contract,
  } = data;
  return new Promise(async (resolve, reject) => {
    try {
      const rwContract = await web3_api.getContractInstance(
        "wallet",
        withdraw_contract,
      );
      rwContract.methods
        .withdraw1(
          contract,
          amount_str,
          fee_str,
          real_amount_str,
          signature_ts,
          signature,
        )
        .send({ from: user_address })
        .on("receipt", (res) => {
          if (res.status === true || res.status === 1 || res.status === 1n) {
            resolve(res);
          } else {
            reject(new Error("Transaction reverted or failed on-chain"));
          }
        })
        .on("error", (error) => {
          return reject(error);
        });
    } catch (error) {
      console.log(error);

      return reject(error);
    }
  });
}

export default {
  recharge1,
  withdraw1
};
